(function () {
  if (window.__sizeChartInit) return;
  window.__sizeChartInit = true;

  var lastTrigger = null;
  var hostObserver = null;

  function watchHostModal(modal, hostModal) {
    // When the parent quick-view / variant popup is removed from the DOM,
    // close this size-chart modal too. The host modal is removed via
    // BzModal.close() -> modalEl.remove(), so observing its parent for
    // childList changes catches the removal reliably.
    if (!hostModal || !hostModal.parentElement) return;
    if (hostObserver) {
      hostObserver.disconnect();
      hostObserver = null;
    }
    var parent = hostModal.parentElement;
    var observer = new MutationObserver(function () {
      if (!document.contains(hostModal)) {
        observer.disconnect();
        if (hostObserver === observer) hostObserver = null;
        if (!modal.hidden) closeModal(modal);
      }
    });
    observer.observe(parent, { childList: true });
    hostObserver = observer;
  }

  function openModal(id, trigger) {
    // Remove any prior body-level instances of this modal so we don't end up
    // with duplicates after the variant popup is reopened.
    document.querySelectorAll('body > [id="' + id + '"]').forEach(function (el) {
      el.remove();
    });

    var modal = document.getElementById(id);
    if (!modal) return;

    var hostModal = trigger ? trigger.closest('bz-modal') : null;

    // Detach from any inner modal and append to <body> so it overlays the
    // whole page (escapes transformed/clipped ancestors).
    document.body.appendChild(modal);
    modal.hidden = false;
    document.body.classList.add('size-chart-open');

    if (hostModal) watchHostModal(modal, hostModal);

    var closeBtn = modal.querySelector('.size-chart-modal__close');
    if (closeBtn) closeBtn.focus();
  }

  function closeModal(modal) {
    if (!modal) return;
    modal.hidden = true;
    document.body.classList.remove('size-chart-open');
    if (hostObserver) {
      hostObserver.disconnect();
      hostObserver = null;
    }
    if (lastTrigger && typeof lastTrigger.focus === 'function') {
      try { lastTrigger.focus(); } catch (e) {}
    }
  }

  document.addEventListener('click', function (e) {
    var openTrigger = e.target.closest('[data-size-chart-open]');
    if (openTrigger) {
      e.preventDefault();
      e.stopPropagation();
      lastTrigger = openTrigger;
      openModal(openTrigger.getAttribute('data-size-chart-open'), openTrigger);
      return;
    }

    var closeTrigger = e.target.closest('[data-size-chart-close]');
    if (closeTrigger) {
      e.preventDefault();
      e.stopPropagation();
      closeModal(closeTrigger.closest('.size-chart-modal'));
      return;
    }

    // Stop clicks inside the dialog from bubbling up to any host modal's
    // "click outside to close" handler.
    if (e.target.closest('.size-chart-modal__dialog')) {
      e.stopPropagation();
    }
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelector('.size-chart-modal:not([hidden])');
    if (open) {
      e.stopPropagation();
      closeModal(open);
    }
  });
})();
